function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.89 77.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.22,1.27c-2.87.69-5.91,1.84-6.75,2.54-2.08,1.72-1.96,7.66.43,21.87,2.06,12.29,4.04,33.34,4.04,43.02,0,3.37.58,6.55,1.41,7.68,1.37,1.88,1.46,1.88,3.45.08,2.72-2.46,3.82-8.52,5.59-30.62.81-10.18,2.16-21.43,2.99-25,2.03-8.7,2.02-17.39-.01-19.43-1.84-1.84-4.02-1.86-11.14-.14",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.53,5.35c.67,2.68-1.14,17.15-2.64,21.11-.78,2.05-1.57,2.37-5.79,2.37h-4.89l-1.64-8.25C1.74,11.36,1.56,7.97,2.82,5.98c.99-1.56,5.97-2.9,11.35-3.05,3.19-.09,3.82.26,4.36,2.41",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,37.31c-1.43,26.31-3.4,39.94-5.28,36.39-.4-.76-1.01-7.55-1.35-15.11-.34-7.56-.91-16.78-1.25-20.5l-.62-6.76,4.41-.02,4.41-.02-.33,6.02",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg42);
export default __webpack_public_path__ + "static/media/42.d6d3b80ed24e2dddac62da45ceb35971.svg";
export { ForwardRef as ReactComponent };